import React from 'react'

/**
 * Container app info
 * @param {object} props
 * @param {string} props.name
 * @param {string} props.value
 * @param {string} props.title
 * @param {function} props.onClick
 *
 * @returns {React.Component}
 */
const Tab = (props) => {
  const { value, name, title, onClick } = props

  return (
    <div
      className={`integrations-app-edit__scopes-tab ${value === name ? '' : 'secondary-tab' }`}
      onClick={value === name ? null : () => onClick(name)}
    >
      {title}
    </div>
  )
}

export default Tab
